import {TrackingChangeBaseBehavior} from '../../tracking-change-base-behavior';
import {BpmnExtensionHelper} from '../../../../../../app/shared/bpmn-io/bpmn-extension-helper';
import EventBus from 'diagram-js/lib/core/EventBus';
import {CommandType} from '../../../../../../app/shared/bpmn-io/bpmn-js';
import {is} from 'bpmn-js/lib/util/ModelUtil';
import {subProcessType, taskType} from '../../../../../../../../../ispm-web/shared/modules/bpmn/index';
import {TrackingChangeType} from 'diagram-js/lib/model';
import {connection, exclusiveGatewayType} from '@ispm-shared/modules/bpmn/diagram-element-terms';

export class MarkElementDeletedBehavior extends TrackingChangeBaseBehavior {

  constructor(eventBus: EventBus, moddle, modeling, bpmnExtensionHelper: BpmnExtensionHelper) {
    super(eventBus, moddle, modeling, bpmnExtensionHelper);
    super.postExecuted([CommandType.MARK_NODE_DELETED, CommandType.MARK_CONNECTION_DELETED], this.markElementForChange.bind(this));
  }


  getChangeType(): TrackingChangeType {
    return 'deleted';
  }


  extractElementsFromEvent(event) {
    return event.context.elementsToRemove.filter(element => is(element, subProcessType) || is(element, taskType) || is(element, connection) || is(element, exclusiveGatewayType));
  }
}
